<template>
  <v-card flat>
    <v-card-title>
      <span class="headline">Add Subscription Type</span>
      <v-spacer></v-spacer>
      <v-btn
        icon
        small
        @click="$emit('close-dialog')"
      >
        <v-icon>
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="mt-5">
      <v-form>
        <v-text-field
          v-model="typeName"
          outlined
          dense
          label="Type Name"
          placeholder="e.g. Hosting, Licence, Support"
          :error-messages="errorMessages.name"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions class="py-5">
      <v-btn
        color="error"
        outlined
        @click="$emit('close-dialog')"
      >
        Close
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        @click="saveSubscriptionType()"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  mdiClose
} from '@mdi/js'
import { ref, onUnmounted } from '@vue/composition-api'
import invoiceStoreModule from '../invoiceStoreModule'
import store from '@/store'

export default {
  setup(props, { emit }) {
    const INVOICE_APP_STORE_MODULE_NAME = 'app-invoice'

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) {
      store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })

    const typeName = ref('')
    const errorMessages = ref([])

    const saveSubscriptionType = () => {
      errorMessages.value = []

      store
        .dispatch('app-invoice/addSubscriptionType', { name: typeName.value })
        .then(response => {
          store.dispatch("addNotification", { message: "Subscription type was added.", type: "success" })
          typeName.value = ''
          emit('close-dialog')
          emit('refresh-types')
        })
        .catch(error => {
          errorMessages.value = error.response.data.error
        })
    }

    return {
      typeName,
      saveSubscriptionType,
      errorMessages,

      icons: {
        mdiClose
      },
    }
  }
}
</script>

<style lang="css" scoped>
</style>


